import { createSlice } from '@reduxjs/toolkit'
import {
  fetchOrderDetails,
  fetchOrderUnitDetails,
  fetchSetOrderUnitPaid,
  fetchUpdateLot,
} from './thunk'

const initialState = {
  orderDetails: {},
  fetchOrderDetailsLoading: false,
  fetchOrderDetailsError: undefined,
  orderUnitDetails: {},
  orderUnitLoading: false,
  orderUnitError: undefined,
  lotDetails: {},
  lotLoading: false,
  lotError: undefined,
  orderUnitPaidDetails: {},
  orderUnitPaidError: undefined,
  orderUnitPaidLoading: false,
}

const slice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    filterLotsByStatus(state, { payload }) {
      const orderU = state.orderDetails.orderUnits
      const filtered = orderU?.filter(
        (lot) => lot.status.id === payload.statusId
      )

      state.orderDetails = { ...state.orderDetails, orderUnits: filtered }
    },
  },
  extraReducers: {
    [fetchOrderDetails.pending]: (state) => {
      state.fetchOrderDetailsLoading = true
    },
    [fetchOrderDetails.fulfilled]: (state, action) => {
      state.orderDetails = action.payload
      state.fetchOrderDetailsLoading = false
    },
    [fetchOrderDetails.rejected]: (state, { error }) => {
      state.fetchOrderDetailsLoading = false
      state.fetchOrderDetailsError = error
    },
    [fetchOrderUnitDetails.pending]: (state) => {
      state.orderUnitLoading = true
    },
    [fetchOrderUnitDetails.fulfilled]: (state, { payload }) => {
      state.orderUnitLoading = false
      state.orderUnitDetails = payload
    },
    [fetchOrderUnitDetails.rejected]: (state, { error }) => {
      state.orderUnitLoading = false
      state.orderUnitError = error
      state.orderUnitDetails = null
    },
    [fetchUpdateLot.pending]: (state) => {
      state.lotLoading = true
    },
    [fetchUpdateLot.fulfilled]: (state, { payload }) => {
      state.lotLoading = false
      state.lotDetails = payload
    },
    [fetchUpdateLot.rejected]: (state, { error }) => {
      state.lotLoading = false
      state.lotError = error
    },
    [fetchSetOrderUnitPaid.pending]: (state) => {
      state.orderUnitPaidLoading = true
    },
    [fetchSetOrderUnitPaid.fulfilled]: (state, { payload }) => {
      state.orderUnitPaidLoading = false
      state.orderUnitPaidDetails = payload
    },
    [fetchSetOrderUnitPaid.rejected]: (state, { error }) => {
      state.orderUnitPaidLoading = false
      state.orderUnitPaidError = error
    },
  },
})

export const { filterLotsByStatus } = slice.actions

export const reducer = slice.reducer
export const selectorOrders = (state) => state[slice.name]

export default slice
